import {getPUMACountry, getPUMARegion, getPUMAStage} from "../utils/network/BaseURLUtils";
import {getStationCode} from "../utils/network/BaseURLUtils";

export function pumaInit(){
    const appId = '8502c201-1d4f-4874-9259-ef164c155711';
    window.PUMA.initialize({"appId": appId,
        environment:{country: getPUMACountry(), region: getPUMARegion(), stage: getPUMAStage()}});
}

export function emitAnalyticsEvent (metricName, metricData ) {
    // As per PUMA analytics event schema 1.0.0
    try {
        window.PUMA.track(metricName, metricData);
    } catch (e) {
        console.warn("Exception in PUMA Analytics");
    }
}

export function publishLatencyToDolphinCSM(startTime, metricName) {
    try {
        let metricValue = getTimeDiff(startTime);
        const processName = "DOLPHIN_INDUCT_" + getStationCode();

        const getPMETMetric = window.PUMA.createMethodContext(processName);
        const latencyMetric = metricName + "-latency";
        getPMETMetric.publishTimer(latencyMetric, metricValue);
    } catch (e) {
        console.warn("Exception in PUMA Latency Publish");
    }
}

export function publishCountToDolphinCSM(metricName) {
    try {
        const processName = "DOLPHIN_INDUCT_" + getStationCode();
        const customMetric = processName + "-" + metricName;
        window.PUMA.track(customMetric);

        const getPMETMetric = window.PUMA.createMethodContext(processName);
        getPMETMetric.publishCounter(metricName, 1);
    } catch (e) {
        console.warn("Exception in PUMA Count Publish");
    }
}

function getTimeDiff(time) {
    return Date.now() - time ;
}


// WEBPACK FOOTER //
// ./src/components/helper/PUMAMetricHelper.js